import React from "react"

const Expert = ({item, onSelect, selected}) => {
  return (<div
    className={"slide " + (selected ? "slide-active" : "")}
    onClick={() => onSelect(item)}>
    <div className={"expert-image-wrapper"}>
      <img src={item.user_small_picture}/>
      <span className={"black-hover"}/>
    </div>
    <div className={"name"}>{item["label"]}</div>
    <div className={"position"}>{item["position"]}</div>
  </div>)
}

export default Expert
